import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Theme,
  WithStyles,
  withStyles,
  Grid,
  ListItem,
  ListItemText,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import * as React from "react";
import ButtonBase from "@material-ui/core/ButtonBase";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import AddIcon from "@material-ui/icons/Add";
import AddQuestionDialog from "./AddQuestionDialog";
import RenderImagesDialog from "./RenderImagesDialog";
import { isEmpty } from "../constants/constants";
import imagePlacholder from "../assets/images/image-placeholder.png";
import GenericDialog from "./GenericDialog";
import SortableListComponent from "../components/SortableListComponent";
import Autocomplete from "@material-ui/lab/Autocomplete";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = (theme: Theme) =>
  createStyles({
    button: { margin: theme.spacing(2) },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sorting: {
      zIndex: theme.zIndex.modal + 100,
    },
    image: {
      width: 128,
      height: 128,
    },
    table: {
      minWidth: 150,
    },
    margin: {
      margin: theme.spacing(1),
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
    sortable: {
      cursor: "default",
      visibility: "visible",
      zIndex: 99999999,
      listStyle: "none",
      padding: 10,
    },
  });
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  handleClose: any;
  legends: any;
  handleOnSubmit: any;
  handleDeleteQuestion: any;
  uniqueMachineNumbers: any;
  inspectionItems: any;
  uniqueNames: any;
  uniqueTypes: any;
  equipments: any;
  companyData: any;
  images: any;
  editData: any;
}

class AddInspectionItemDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
    questions: Array<any>(),
    titleValue: "",
    selectedQuestion: { question: "" },
    selectedIndex: -1,
    type: "",
    openDeleteQuestionDialog: false,
    questionSelectedIndex: -1,
    openAddQuestionDialog: false,
    openRenderImagesDialog: false,
    linkedToRetriveOption: false,
    retreiveOptionSelected: { value: "", label: "" },
    selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
  };
  resetState = () => {
    this.setState({
      showPassword: false,
      hasError: false,
      questions: Array<any>(),
      titleValue: "",
      selectedQuestion: { question: "" },
      selectedIndex: -1,
      type: "",

      openAddQuestionDialog: false,
      openRenderImagesDialog: false,
      selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
    });
  };
  componentDidMount = () => {
    this.setState({
      questions: this.props.editData.questions
        ? this.props.editData.questions
        : [],
      title: this.props.editData.title ? this.props.editData.title : "",
      linkedToRetriveOption: this.props.editData.linkedToRetriveOption
        ? this.props.editData.linkedToRetriveOption
        : false,
      retreiveOptionSelected: this.props.editData.retreiveOptionSelected
        ? this.props.editData.retreiveOptionSelected
        : { value: "", label: "" },
      selectedImageItem: {
        base64: this.props.editData.base64 ? this.props.editData.base64 : "",
        item: {
          filename:
            this.props.editData.imageItem &&
            this.props.editData.imageItem.filename
              ? this.props.editData.imageItem.filename
              : "",
          _id:
            this.props.editData.imageItem &&
            this.props.editData.imageItem.imageId
              ? this.props.editData.imageItem.imageId
              : "",
        },
      },
    });
  };
  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.editData !== this.props.editData) {
      this.setState({
        questions: this.props.editData.questions,
        titleValue: this.props.editData.title,
        linkedToRetriveOption: this.props.editData.linkedToRetriveOption
          ? this.props.editData.linkedToRetriveOption
          : false,
        retreiveOptionSelected: this.props.editData.retreiveOptionSelected
          ? this.props.editData.retreiveOptionSelected
          : { value: "", label: "" },
        selectedImageItem: {
          base64: this.props.editData.base64,
          item: {
            filename:
              this.props.editData.imageItem &&
              this.props.editData.imageItem.filename
                ? this.props.editData.imageItem.filename
                : "",
            _id:
              this.props.editData.imageItem &&
              this.props.editData.imageItem.imageId
                ? this.props.editData.imageItem.imageId
                : "",
          },
        },
      });
    }
  }

  handleAddButton = () => {
    this.setState({
      openAddQuestionDialog: true,
    });
  };
  handleOnOpenRenderImages = () => {
    this.setState({
      openRenderImagesDialog: true,
    });
  };
  handleSaveButton = () => {
    const { handleOnSubmit } = this.props;
    let values = {
      questions: {},
      title: "",
      imageItem: { filename: "", imageId: "" },
      base64: "",
      linkedToRetriveOption: false,
      retreiveOptionSelected: { value: "", label: "" },
    };
    values.title = this.state.titleValue;
    values.questions = this.state.questions;
    values.linkedToRetriveOption = this.state.linkedToRetriveOption;
    values.retreiveOptionSelected = this.state.retreiveOptionSelected;
    values.imageItem = {
      filename: this.state.selectedImageItem.item.filename,
      imageId: this.state.selectedImageItem.item._id,
    };
    values.base64 = this.state.selectedImageItem.base64;
    if (handleOnSubmit) {
      this.resetState();
      handleOnSubmit(values);
    }
  };
  onTextTitleChanged = (event: any) => {
    this.setState({
      titleValue: event.target.value,
    });
  };
  isValid = () => {
    // let { editData } = this.props;
    // if (editData && !isEmpty(editData)) {
    //   let questionsValid =
    //     editData.questions && editData.questions.length > 0 ? true : false;
    //   let titleValueValid =
    //     !editData.title || 0 === editData.title.length ? false : true;
    //   return !questionsValid || !titleValueValid;
    // } else {
    let questionsValid =
      this.state.questions && this.state.questions.length > 0 ? true : false;
    let titleValueValid =
      !this.state.titleValue || 0 === this.state.titleValue.length
        ? false
        : true;
    return !questionsValid || !titleValueValid;
    // }
  };
  handleEditQuestion = (question: any, index: any) => {
    this.setState({
      selectedQuestion: question,
      selectedIndex: index,
      openAddQuestionDialog: true,
    });
  };
  handleDeleteQuestion = (question: any, index: any) => {
    this.setState({
      openDeleteQuestionDialog: true,
      questionSelectedIndex: index,
      selectedQuestion: question,
    });
  };
  onAddQuestionSubmit = (values: any) => {
    values.legend = this.getLegend(values.legend);
    let questions = this.state.questions ? this.state.questions : [];
    questions.push(values);
    this.setState({
      questions: questions,
      openAddQuestionDialog: false,
    });
  };
  onEditQuestionSubmit = (values: any) => {
    if (this.state.selectedIndex > -1) {
      values.legend = this.getLegend(values.legend);
      let questions = this.state.questions ? this.state.questions : [];
      questions[this.state.selectedIndex] = values;
      this.setState({
        questions: questions,
        selectedQuestion: {},
        selectedIndex: -1,
        openAddQuestionDialog: false,
      });
    }
  };
  renderAddQuestionDialog = () => {
    return (
      <AddQuestionDialog
        title={"Add Question"}
        open={this.state.openAddQuestionDialog}
        handleClose={() =>
          this.setState({
            openAddQuestionDialog: false,
            selectedIndex: -1,
            selectedQuestion: {},
          })
        }
        legends={this.props.legends}
        editData={
          this.state.selectedQuestion ? this.state.selectedQuestion : undefined
        }
        uniqueMachineNumbers={this.props.uniqueMachineNumbers}
        uniqueNames={this.props.uniqueNames}
        uniqueTypes={this.props.uniqueTypes}
        equipments={this.props.equipments}
        companyData={this.props.companyData}
        handleOnSubmit={
          this.state.selectedQuestion && this.state.selectedQuestion.question
            ? this.onEditQuestionSubmit
            : this.onAddQuestionSubmit
        }
      />
    );
  };

  renderImagesDialog = () => {
    return (
      <RenderImagesDialog
        open={this.state.openRenderImagesDialog}
        companyData={this.props.companyData}
        onClose={() => {
          this.setState({
            openRenderImagesDialog: false,
          });
        }}
        onSelectedItem={this.handleOnImageSelected}
        dialogTitle={"Choose Image"}
        images={this.props.images}
      />
    );
  };

  getLegend = (legend: any) => {
    const { legends } = this.props;
    let result = legends.filter((item: any) => item.legendCode === legend);
    return result.length > 0 ? result[0] : undefined;
  };

  handleOnImageSelected = (imageItem: any) => {
    this.setState({
      openRenderImagesDialog: false,
      selectedImageItem: imageItem,
    });
  };

  handleClose = () => {
    this.setState({
      openDeleteQuestionDialog: false,
    });
  };

  handleConfirmedDelete = () => {
    const { handleDeleteQuestion } = this.props;
    if (handleDeleteQuestion) {
      handleDeleteQuestion(
        this.state.selectedQuestion,
        this.state.questionSelectedIndex
      );
      this.setState({
        openDeleteQuestionDialog: false,
      });
    }
    // let questions = this.state.questions;
    // questions.splice(this.state.questionSelectedIndex, 1);
    // this.setState({
    //   questions: questions,
    //   openDeleteQuestionDialog: false
    // });
  };
  renderConfirmationDialog = () => {
    // const { companyData } = this.props;
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting question`}
        messages={[
          "Are you sure want to delete this question",
          `${this.state.selectedQuestion.question}`,
        ]}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openDeleteQuestionDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  onSortFinish = (newSortedArray: any) => {
    this.setState({
      questions: newSortedArray,
    });
  };

  getRetriveOptions = () => {
    const { inspectionItems } = this.props;
    let newRetriveOption = new Array<any>();
    inspectionItems &&
      inspectionItems.map((inspectionItem: any) => {
        inspectionItem.questions.map((questionItem: any) => {
          if (
            questionItem.responseType &&
            questionItem.responseType.title === "Options"
          ) {
            if (
              questionItem.retrieveDetails &&
              questionItem.retrieveDetails.retrieveItems
            )
              newRetriveOption.push(
                ...questionItem.retrieveDetails.retrieveItems
              );
          }
        });
      });
    return newRetriveOption;
  };

  render() {
    const { title, open, handleClose, classes } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          maxWidth={"lg"}
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item>
                <ButtonBase className={classes.image}>
                  {this.state.selectedImageItem.base64 &&
                  !isEmpty(this.state.selectedImageItem.base64) ? (
                    <img
                      className={classes.img}
                      alt="complex"
                      src={`data:image/jpeg;base64,${this.state.selectedImageItem.base64}`}
                    />
                  ) : (
                    <img
                      className={classes.img}
                      alt="complex"
                      src={imagePlacholder}
                    />
                  )}
                </ButtonBase>
                <Grid item>
                  <Paper
                    elevation={3}
                    style={{
                      width: "100%",
                      height: 50,
                      margin: 10,
                      alignSelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      size="small"
                      style={{
                        backgroundColor: "white",
                        color: "grey",
                        height: 48,
                        width: "100%",
                      }}
                      onClick={() => this.handleOnOpenRenderImages()}
                      startIcon={<CloudUploadIcon />}
                    >
                      Upload
                    </Button>
                  </Paper>
                </Grid>
              </Grid>
              <Grid item xs={12} sm container>
                <Grid item xs container direction="column" spacing={2}>
                  <Grid item xs>
                    <ListItem>
                      <TextField
                        id={"title"}
                        name={"title"}
                        label={"Title"}
                        value={
                          this.state.titleValue ? this.state.titleValue : ""
                        }
                        fullWidth={true}
                        onChange={(event) => this.onTextTitleChanged(event)}
                      />
                    </ListItem>
                    <ListItem>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="showAlert"
                            checked={this.state.linkedToRetriveOption}
                            onChange={(event: any) => {
                              this.setState({
                                linkedToRetriveOption: event.target.checked,
                              });
                            }}
                          />
                        }
                        label="Link to Retrive Option"
                        value={this.state.linkedToRetriveOption}
                      />
                    </ListItem>
                    {this.state.linkedToRetriveOption && (
                      <ListItem>
                        <Autocomplete
                          freeSolo
                          style={{ flex: 1, paddingLeft: 5 }}
                          options={this.getRetriveOptions()}
                          value={this.state.retreiveOptionSelected}
                          onChange={(event: any, value: any) => {
                            this.setState({
                              retreiveOptionSelected: value,
                            });
                          }}
                          getOptionLabel={(option) =>
                            option && option.label ? option.label : ""
                          }
                          renderOption={(option: any) => (
                            <React.Fragment>
                              <ListItemText primary={option.label} />
                            </React.Fragment>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              margin="normal"
                              variant="outlined"
                              placeholder={"Select linked retrieve option"}
                              style={{ width: "100%" }}
                            />
                          )}
                        />
                      </ListItem>
                    )}
                    <ListItem>
                      <ListItemText primary="Inspection Questions" />
                      <Button
                        variant="contained"
                        className={classes.button}
                        startIcon={<AddIcon />}
                        onClick={() => this.handleAddButton()}
                      >
                        Add Inspection
                      </Button>
                    </ListItem>
                    {this.state.questions && (
                      <SortableListComponent
                        items={this.state.questions}
                        sorting={classes.sorting}
                        onSortFinish={this.onSortFinish}
                        editAction={this.handleEditQuestion}
                        deleteAction={this.handleDeleteQuestion}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleClose();
              }}
            >
              {"CANCEL"}
            </Button>
            <Button
              disabled={this.isValid()}
              onClick={() => this.handleSaveButton()}
            >
              {"SAVE"}
            </Button>
          </DialogActions>
        </Dialog>
        {this.renderAddQuestionDialog()}
        {this.renderImagesDialog()}
        {this.renderConfirmationDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddInspectionItemDialog);
